import type { ConstantsTeamUserInviteStruct } from "@gosaas/types";
import { useQuery } from "@tanstack/react-query";
import { apiClient, requestWithHandling } from "@/utils/api";
import { reportQueryError } from "@/utils/query-errors";

export const useFetchUserInvites = () => {
	const {
		data: userInvites,
		isLoading: isLoadingInvites,
		refetch: refetchInvites,
	} = useQuery({
		queryKey: ["user-invites`"],
		queryFn: async () => {
			try {
				const response = await requestWithHandling<
					ConstantsTeamUserInviteStruct[]
				>(() => apiClient.api.userTeamsInvitesList());
				if (response.code !== "SUCCESS") {
					throw new Error(response.message || "Failed to load team invites");
				}
				return response.data;
			} catch (err) {
				reportQueryError(err, { title: "Failed to load team invites" });
			}
		},
		retry: 1,
		retryDelay: 1000,
	});

	return { userInvites, isLoadingInvites, refetchInvites };
};
